const Point1Illustration = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48 0H8C3.58172 0 0 3.58172 0 8V48C0 52.4183 3.58172 56 8 56H48C52.4183 56 56 52.4183 56 48V8C56 3.58172 52.4183 0 48 0Z"
      fill="#FFCCEF"
    />
    <mask
      id="mask0_2979_636"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="56"
      height="56"
    >
      <path
        d="M48 0H8C3.58172 0 0 3.58172 0 8V48C0 52.4183 3.58172 56 8 56H48C52.4183 56 56 52.4183 56 48V8C56 3.58172 52.4183 0 48 0Z"
        fill="#FFCCEF"
      />
    </mask>
    <g mask="url(#mask0_2979_636)">
      <rect x="11.2002" y="28" width="44.8" height="28" fill="#FB6E44" />
      <path d="M11.2 28L0 56H22.4L11.2 28Z" fill="#F4EFED" />
      <rect x="22.3994" y="32.0835" width="33.6" height="8.05" fill="#0A0777" />
      <path
        d="M48.8268 30.8924C47.2903 27.0792 43.5619 24.3838 39.1987 24.3838C34.8355 24.3838 31.106 27.0782 29.5706 30.8924C29.0886 32.09 28.8164 33.3957 28.8164 34.7657C28.8164 36.733 29.3743 38.5664 30.3248 40.1338H48.0747C49.0252 38.5664 49.5831 36.733 49.5831 34.7657C49.5831 33.3957 49.3109 32.09 48.8289 30.8924H48.8268Z"
        fill="white"
      />
    </g>
  </svg>
);

export default Point1Illustration;
